import { notificationMessagesGetters } from '@/store/modules/notificationMessages/routines'

export default {
  [notificationMessagesGetters.HAS_NEW_NOTIFICATION_MESSAGES]: state => state.hasNewNotificationMessages
}
